export enum FuelIndexingEnum {
  PRIX_CNR_GAZOLE_CUVE_MOYENNE_MENSUELLE = 'PRIX_CNR_GAZOLE_CUVE_MOYENNE_MENSUELLE',
  INDICE_CNR_GAZOLE_PROFESSIONNEL = 'INDICE_CNR_GAZOLE_PROFESSIONNEL',
  INDICE_CNR_GAZOLE_HORS_TVA = 'INDICE_CNR_GAZOLE_HORS_TVA',
  PRIX_GAZOLE_POMPE_MOYENNE_MENSUELLE = 'PRIX_GAZOLE_POMPE_MOYENNE_MENSUELLE',
  PRIX_CNR_GAZOLE_CUVE_FIN_DE_MOIS = 'PRIX_CNR_GAZOLE_CUVE_FIN_DE_MOIS',
}
